import { createSlice, createAsyncThunk, createAction } from "@reduxjs/toolkit";
import bookingService from "./bookingService";

// Create a booking (POST request)
export const createBooking = createAsyncThunk(
  "booking/createBooking",
  async (bookingData, thunkAPI) => {
    try {
      return await bookingService.createBooking(bookingData);
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response?.data?.message || error.message);
    }
  }
);

// Reset state
export const resetState = createAction("Reset_all");

const initialState = {
  booking: null,  // Change from an array to null since it's a single booking
  isError: false,
  isLoading: false,
  isSuccess: false,
  message: "",
};

export const bookingSlice = createSlice({
  name: "booking",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(createBooking.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(createBooking.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isError = false;
        state.isSuccess = true;
        state.booking = action.payload; // Store the created booking
      })
      .addCase(createBooking.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.isSuccess = false;
        state.message = action.payload; // Store error message
      })
      .addCase(resetState, () => initialState);
  },
});

export default bookingSlice.reducer;
